import { Badge } from '@shared/components/ui/badge';
import { useTranslation } from 'react-i18next';
import { PackageStatus } from '../../models/Reception';

interface PackageStatusBadgeProps {
  status: PackageStatus;
}

/**
 * Badge que muestra el estado de un paquete
 */
export const PackageStatusBadge: React.FC<PackageStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation('receptionsModule');

  const getVariant = (): 'default' | 'secondary' | 'success' | 'warning' | 'destructive' => {
    switch (status) {
      case 'RECEIVED':
        return 'warning';
      case 'IDENTIFIED':
        return 'success';
      default:
        return 'default';
    }
  };

  const getLabel = (): string => {
    switch (status) {
      case 'RECEIVED':
        return t('package_status.received');
      case 'IDENTIFIED':
        return t('package_status.identified');
      default:
        return status;
    }
  };

  return (
    <Badge variant={getVariant()} className="whitespace-nowrap">
      {getLabel()}
    </Badge>
  );
};

export default PackageStatusBadge;
